<template>
  <div class="app-container">
    <list ref="list">
        <template slot="toolbar-right" v-if="$permission.canWrite()">
            <el-button type="primary" @click="_create" icon="el-icon-plus">添加</el-button>
            <el-button type="danger" @click="delRows">删除</el-button>
        </template>
        <template slot="column">
            <!-- <el-table-column label="操作" fixed="right" align="center" width="60"> -->
            <el-table-column label="操作" fixed="right" align="center" width="160">
                <template slot-scope="{row}">
                    <el-button v-if="$permission.canWrite()" type="text" @click="_edit(row)">编辑</el-button>
                </template>
            </el-table-column>
      </template>
    </list>
    <edit-dialog ref="editDialog" @close-saved="reload" :disabled="disabled"></edit-dialog>
  </div>
</template>
<script>
import curdMixins from "@/mixins/trend/curd";
import list from '@/components/production/craftsmanship/archives/list'
import editDialog from '@/components/production/craftsmanship/archives/editDialog'

export default {
  name: "archives",
  mixins: [curdMixins],
  components: {
    list,
    editDialog
  },
  data(){
    return {
      disabled: false,
    }
  },
  methods: {
    delRows(){
      this.$refs.list._del();
    },
    _edit(row){
      this.disabled = true;
      this.edit(row)
    },
    _create(){
        this.disabled = false;
      this.create();
    }
    
  }
  
};
</script>